import React from 'react';
import Paper from '@material-ui/core/Paper';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  type?: 'success' | 'error';
}

const useStyles = makeStyles((theme) => ({
  root: ({ color }: { color: 'error' | 'primary' }) => ({
    background: `${theme.palette[color].main}10`,
    border: `1px solid ${theme.palette[color].main}`,
    borderRadius: '3px',
    color: theme.palette[color].main,
    fontSize: '12px',
    padding: '10px',
  }),
}));

const Alert: React.FC<Props> = ({ children, type = 'error' }) => {
  const color = type === 'success' ? 'primary' : type;
  const classes = useStyles({ color });
  return (
    <Paper classes={classes} elevation={0}>
      {children}
    </Paper>
  );
};

export default Alert;
